"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventWithHeap = exports.UPDATE_TABLE_STATE = exports.UPDATE_SYNCED_STATE = exports.UPDATE_SPECIALTY_STATE = exports.UPDATE_SEARCH_STATE = exports.UPDATE_FEEDBACK_STATE = exports.SEARCH_IN_PROGRESS = exports.SEARCH_COMPLETE = exports.PF_PROVIDER_FUZZY_CONVERSION_EVENT = exports.PF_PROVIDER_ELASTIC_SEARCH_EVENT = exports.PENDING = exports.NOMATCH = exports.MORE_PENDING = exports.MORE_COMPLETE = exports.LCYTS = exports.LCPS = exports.LCK12 = exports.FUZZY = exports.EXACT = exports.ERROR = exports.COMPLETE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var UPDATE_SEARCH_STATE = 'UPDATE_SEARCH_STATE';
exports.UPDATE_SEARCH_STATE = UPDATE_SEARCH_STATE;
var UPDATE_TABLE_STATE = 'UPDATE_TABLE_STATE';
exports.UPDATE_TABLE_STATE = UPDATE_TABLE_STATE;
var SEARCH_IN_PROGRESS = 'SEARCH_IN_PROGRESS';
exports.SEARCH_IN_PROGRESS = SEARCH_IN_PROGRESS;
var SEARCH_COMPLETE = 'SEARCH_COMPLETE';
exports.SEARCH_COMPLETE = SEARCH_COMPLETE;
var UPDATE_SPECIALTY_STATE = 'UPDATE_SPECIALTY_STATE';
exports.UPDATE_SPECIALTY_STATE = UPDATE_SPECIALTY_STATE;
var UPDATE_FEEDBACK_STATE = 'UPDATE_FEEDBACK_STATE';
exports.UPDATE_FEEDBACK_STATE = UPDATE_FEEDBACK_STATE;
var UPDATE_SYNCED_STATE = 'UPDATE_SYNCED_STATE';
exports.UPDATE_SYNCED_STATE = UPDATE_SYNCED_STATE;
var PF_PROVIDER_ELASTIC_SEARCH_EVENT = 'PF_PROVIDER_ELASTIC_SEARCH_EVENT';
exports.PF_PROVIDER_ELASTIC_SEARCH_EVENT = PF_PROVIDER_ELASTIC_SEARCH_EVENT;
var PF_PROVIDER_FUZZY_CONVERSION_EVENT = 'PF_PROVIDER_FUZZY_CONVERSION_EVENT';
exports.PF_PROVIDER_FUZZY_CONVERSION_EVENT = PF_PROVIDER_FUZZY_CONVERSION_EVENT;
var MORE_COMPLETE = 'MORE_COMPLETE';
exports.MORE_COMPLETE = MORE_COMPLETE;
var MORE_PENDING = 'MORE_PENDING';
exports.MORE_PENDING = MORE_PENDING;
var COMPLETE = 'COMPLETE';
exports.COMPLETE = COMPLETE;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var LCYTS = 'LCYTS';
exports.LCYTS = LCYTS;
var LCK12 = 'LCK12';
exports.LCK12 = LCK12;
var LCPS = 'LCPS';
exports.LCPS = LCPS;
var FUZZY = 'Fuzzy';
exports.FUZZY = FUZZY;
var EXACT = 'Exact';
exports.EXACT = EXACT;
var NOMATCH = 'No Match';
exports.NOMATCH = NOMATCH;
var ERROR = 'error';
exports.ERROR = ERROR;
var trackEventWithHeap = function trackEventWithHeap(evntNm, payload) {
  var finalPayLoad = _objectSpread(_objectSpread({}, {
    eventName: evntNm
  }), payload);
  if (window.lcTracking && window.lcTracking.trackCustomEvent) {
    window.lcTracking.trackCustomEvent(finalPayLoad, {});
  }
};
exports.trackEventWithHeap = trackEventWithHeap;
